// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AlarmClass, CreateAlarmClassCommand, UpdateAlarmClassCommand } from './types'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'



// Define a service using a base URL and expected endpoints
export const alarmClassApi = createApi({
  reducerPath: 'alarmClassApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.alarmClassesApiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['AlarmClasses'],
  endpoints: (builder) => ({
    getAlarmClassById: builder.query<AlarmClass, string>({
      query: (id) => `/${id}`,
    }),
    getAllAlarmClasses: builder.query<AlarmClass[], void>({
      query: () => `/`,
      transformResponse: (response: { data: AlarmClass[] }, meta, arg) => response.data,
      providesTags: ['AlarmClasses'],
    }),
    createAlarmClass: builder.mutation<AlarmClass, CreateAlarmClassCommand>({
      query: (obj) => ({
        url: `/new`,
        method: 'post',
        body: obj
      }),
      invalidatesTags: ['AlarmClasses']
    }),
    updateAlarmClass: builder.mutation<AlarmClass, UpdateAlarmClassCommand>({
      query: (obj) => ({
        url: `/${obj.id}`,
        method: 'post',
        body: obj
      }),
      invalidatesTags: ['AlarmClasses']
    }),
    deleteAlarmClass: builder.mutation<AlarmClass, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['AlarmClasses']
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAlarmClassByIdQuery,
  useGetAllAlarmClassesQuery,
  useCreateAlarmClassMutation,
  useUpdateAlarmClassMutation,
  useDeleteAlarmClassMutation
} = alarmClassApi